<template>
  <el-form-item
    :label="titlize(label)"
    :rules="metaData.is_required ? requiredField() : []"
  >
    <el-date-picker
      :ref="`input-field-${formIndex}`"
      v-model="selectedDate"
      type="date"
      @focus="changeColor($event)"
      @blur="resetColor($event)"
      @change="validateInput()"
      :format="defaultFormat"
      :placeholder="`Select ${titlize(label)}`"
      :disabled="preview"
    >
    </el-date-picker>

    <div class="el-form-item__error">
      {{ errMsg }}
    </div>
  </el-form-item>
</template>

<script>
import { titleCase } from "@/lib/utils";

export default {
  name: "TextInput",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Date]
    },
    metaData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    },
    parentForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      input: "",
      selectedDate: "",
      errMsg: "",
      defaultFormat: "yyyy-MM-dd"
    };
  },
  inject: ["preview"],

  computed: {
    setValue: {
      get() {
        return this.selectedDate;
      },
      set(value) {
        this.$emit("update:value", new Date(value).toISOString().slice(0, 10));
      }
    },
    preview() {
      return this.preview;
    }
  },
  methods: {
    validateInput() {
      if (!this.metaData.is_required && !this.setValue) {
        return;
      }
      if (this.metaData.is_required && !this.setValue) {
        this.errMsg = `${this.titlize(this.label)} is required`;
        this.$emit("isValid", false);
      } else {
        this.errMsg = "";
      }
    },

    resetColor(evt) {
      this.validateInput();
      evt.$el.getElementsByClassName("el-input__inner")[0];
    },

    changeColor(evt) {
      evt.$el.getElementsByClassName("el-input__inner")[0];
    },

    titlize(option) {
      return titleCase(option);
    }
  },
  watch: {
    selectedDate(val) {
      this.setValue = val;
    }
  }
};
</script>

<style lang="scss" scoped></style>
